import type { ExcelDownloadClient } from "app/components/React/ExcelButton/ExcelClientDownload";
import type { IFetchService } from "app/services/fetchService";
import type { ExcelDownloadRequestDto, CompetitiveLandscapeResults } from "../../types/dto";

const createCompetitiveLandscapeApiService = (
    fetchService: IFetchService,
    excelDownloadClient: ExcelDownloadClient,
) => {
    return {
        fetchCompetitiveResults(params: string): Promise<CompetitiveLandscapeResults> {
            return fetchService.get(`/sales-api/account-overview/similar-sites/table?${params}`);
        },
        downloadExcel(dto: ExcelDownloadRequestDto, params: string) {
            return excelDownloadClient(`/sales-api/account-overview/similar-sites/excel?${params}`, dto);
        },
    };
};

export default createCompetitiveLandscapeApiService;
